module.exports = __webpack_public_path__ + "img/battlelock.31e0fc61.png";